import { apiClient as api } from "./httpClient";

export interface ProfessionalTeamItem {
  id: string;
  title: string;
  description?: string;
  mainTeam: boolean;
  memberCount: number;
  coordinatorName?: string;
  specificPatients: boolean;
  patientCount: number;
  isActive: boolean;
  createdAt?: string;
}

export interface TeamMemberItem {
  ueprId: string;
  name: string;
  professionalTypeName?: string;
  isCoordinator: boolean;
}

export interface TeamMembersResponse {
  linked: TeamMemberItem[];
  available: TeamMemberItem[];
}

export interface TeamPatientItem {
  patientId: string;
  name: string;
}

export interface TeamPatientsResponse {
  specificPatients: boolean;
  linked: TeamPatientItem[];
  available: TeamPatientItem[];
}

export interface ProfessionalTeamPayload {
  title: string;
  description?: string;
  mainTeam: boolean;
}

export const professionalTeamService = {
  // Escopo: entidade da sessão (o backend resolve pelo query filter)
  getAll: async (): Promise<ProfessionalTeamItem[]> => {
    const response = await api.get("/professional-teams");
    return Array.isArray(response.data) ? response.data : [];
  },
  create: async (payload: ProfessionalTeamPayload): Promise<void> => {
    await api.post("/professional-teams", payload);
  },
  update: async (id: string, payload: ProfessionalTeamPayload): Promise<void> => {
    await api.put(`/professional-teams/${id}`, payload);
  },
  setStatus: async (id: string, active: boolean): Promise<void> => {
    await api.patch(`/professional-teams/${id}/status`, { active });
  },
  remove: async (id: string): Promise<void> => {
    await api.delete(`/professional-teams/${id}`);
  },
  getMembers: async (id: string): Promise<TeamMembersResponse> => {
    const response = await api.get(`/professional-teams/${id}/members`);
    return response.data;
  },
  addMember: async (id: string, ueprId: string): Promise<void> => {
    await api.post(`/professional-teams/${id}/members`, { ueprId });
  },
  removeMember: async (id: string, ueprId: string): Promise<void> => {
    await api.delete(`/professional-teams/${id}/members/${ueprId}`);
  },
  // Coordenador único por equipe (limite do Bubble); null limpa a coordenação
  setCoordinator: async (id: string, ueprId: string | null): Promise<void> => {
    await api.put(`/professional-teams/${id}/coordinator`, { ueprId });
  },
  getPatients: async (id: string): Promise<TeamPatientsResponse> => {
    const response = await api.get(`/professional-teams/${id}/patients`);
    return response.data;
  },
  addPatient: async (id: string, patientId: string): Promise<void> => {
    await api.post(`/professional-teams/${id}/patients`, { patientId });
  },
  removePatient: async (id: string, patientId: string): Promise<void> => {
    await api.delete(`/professional-teams/${id}/patients/${patientId}`);
  },
  setSpecificPatients: async (id: string, specificPatients: boolean): Promise<void> => {
    await api.patch(`/professional-teams/${id}/specific-patients`, { specificPatients });
  },
};
